import React from 'react';

import { shouldRenderLiveUpdatesIndicator } from '../../utils/liveUpdates.utils';

import { UserMenuContainer } from '../../containers/UserMenu.container';
import { ChangelogDialogContainer } from '../../containers/ChangelogDialog.container';
import { SubscriptionsSelectorContainer } from 'src/containers/SubscriptionsSelector.container';
import { AnnouncementBannerContainer } from '../announcement-banner/AnnouncementBanner.container';

import { HeaderButton } from '../header-button/HeaderButton.view';
import UserFeedback from '../user-feedback';
import SesamLink from '../common/Links/SesamLink';
import Search from '@material-ui/icons/SearchOutlined';
import { LiveUpdatesHeaderIndicator } from '../live-updates-header-indicator/LiveUpdatesHeaderIndicator.view';

import { TestID } from '../../testID';

// @ts-ignore
import Logo from '../../images/sesamlogo.svg';

import './AppHeader.css';

const mainLink = '/dashboard';

export const AppHeader: React.FC<{
  connected: boolean;
  isLoggedIn: boolean;
  darkModeActive: boolean;
  isLiveUpdatesSupported: boolean;
  isLiveUpdatesEnabled: boolean;
  subscriptionId?: string;
  subscriptionName?: string;
  isSubscriptionPages: boolean;
  failedToConnectToLiveUpdates?: boolean;
  showDatahubObjectsPalette: () => void;
}> = ({
  connected,
  isLoggedIn,
  darkModeActive,
  isLiveUpdatesSupported,
  isLiveUpdatesEnabled,
  subscriptionId,
  subscriptionName,
  isSubscriptionPages,
  failedToConnectToLiveUpdates,
  showDatahubObjectsPalette,
}) => {
  const isSubscriptionExist = subscriptionId && subscriptionName;

  const logo = isLoggedIn ? (
    <SesamLink to={mainLink} className="app-header__logo">
      <Logo className="app-header__logo-img img-responsive" alt="Logo" />
    </SesamLink>
  ) : (
    <div className="app-header__logo">
      <Logo className="app-header__logo-img img-responsive" alt="Logo" />
    </div>
  );

  return (
    <header>
      <div className={darkModeActive ? 'app-header dark' : 'app-header'}>
        {logo}
        <nav className="app-header__utility-nav">
          {isSubscriptionExist && (
            <SubscriptionsSelectorContainer
              currentSubId={subscriptionId}
              currentSubName={subscriptionName}
            />
          )}
          {/* @ts-ignore */}
          {isLoggedIn && <AnnouncementBannerContainer />}
          {shouldRenderLiveUpdatesIndicator({
            isLoggedIn,
            isSubscriptionPages,
            connected,
            isLiveUpdatesSupported,
            isLiveUpdatesEnabled,
          }) && (
            <div className="live-updates-indicator-icon" title="Live updates enabled">
              <LiveUpdatesHeaderIndicator
                isLiveUpdatesEnabled={isLiveUpdatesEnabled}
                isLiveUpdatesSupported={isLiveUpdatesSupported}
                failedToConnectToLiveUpdates={failedToConnectToLiveUpdates}
              />
            </div>
          )}
          {isLoggedIn && <UserFeedback />}
          {isSubscriptionExist && (
            // @ts-ignore
            <HeaderButton darkModeActive={darkModeActive}>
              <button
                className="btn-link"
                onClick={showDatahubObjectsPalette}
                title="Search datahub…"
                data-testid={TestID.DatahubObjectsPaletteButton}
              >
                <Search />
              </button>
            </HeaderButton>
          )}
          {isLoggedIn && <ChangelogDialogContainer darkModeActive={darkModeActive} />}
          {isLoggedIn && <UserMenuContainer />}
        </nav>
      </div>
    </header>
  );
};
